<template>
  <div class="container-fluid listings" >
    <vue-headful
            :title="`Brokers Real Estate`"
        />
    <div v-if="loading" class="loading text-center">
      <v-progress-linear :size="90" :width="7" color="#bc2025" indeterminate></v-progress-linear>
    </div>
    <Search />
    <!-- <h1>Listings </h1> -->
        <div class="container">
          <v-btn
            fab
            dark
            
            color="blue darken-3"
            class="text-left "
            @click="formerPage"
            
          >
          
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <span
            class="
            text-center
            grey--text"
          >
           <!-- Page {{ page }} of {{ numberOfPages }} -->
          </span>
          <!-- <v-btn
            fab
            dark
            
            color="blue darken-3"
            class="text-right"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn> -->
          <v-pagination
            v-model="page"
            :length="numberOfPages"
            
          ></v-pagination>
          </div>
    <!-- <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>&nbsp; -->
    <v-container fluid class=" px-3">
        <!-- {{ $route.query.param }} -->
    <v-data-iterator
      :items="listings"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
      :loading="loading"
    >
      <template v-slot:header>
        
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="listing in props.items"
            :key="listing.ListingKey"
            cols="12"
            sm="6"
            md="4"
            lg="4"
          >
            <v-card
             height="550"
             class="card-outter"
            >
              
              

                <div class="pt-2">
                  <h4 class="float-left px-3">${{ formatPrice(listing.ListPrice) }}</h4>
                  <div class="text-right px-3" style="margin-top:{-3rem; !important}">
                  <h4 class="text-h4" v-if="listing.MlsStatus == 'Active'">
                    <span class="badge badge-pill badge-success">For Sale</span>
                  </h4>
                  <h4  v-if="listing.MlsStatus == 'Pending'">
                    <span class="badge badge-pill badge-warning">Pending</span>
                  </h4>
                  <h4  v-if="listing.MlsStatus == 'Pending - Taking Backups'">
                    <span class="badge badge-pill badge-warning">Pending - Taking Backup Offers</span>
                  </h4>
                  
                  <h4  v-if="listing.MlsStatus == 'Active Under Contract'">
                    <span class="badge badge-pill badge-warning">Pending - Under Contract</span>
                  </h4>
                  </div>
                  
                  <h5 class="float-right border-top px-3 pt-1"> {{listing.StreetNumber}} {{ listing.StreetName }}, {{listing.City}}</h5>
                  <div class="text-left border-top px-3 pb-2" >
                      <span v-if="listing.BedroomsTotal != NULL"><strong>Beds {{ listing.BedroomsTotal }} </strong></span>
                      <span v-else><strong>Beds -</strong></span>
                      <br>
                      <span v-if="listing.BathroomsTotalInteger != NULL"><strong>Baths {{ listing.BathroomsTotalInteger }} </strong></span>
                      <span v-else><strong>Baths -</strong></span>
                      <br>
                      <span v-if="listing.LivingArea != NULL"><strong> {{ listing.LivingArea }} Sq.Ft.</strong></span>
                      <span v-else><strong>{{listing.LotSizeAcres}} Acres</strong></span>
                  </div>
                </div>
              
             
              <v-img
                  v-if="listing.PhotosCount"
                  max-height="250px"
                  v-bind:src="listing.Media[0].MediaURL"
              >
              </v-img>
              <v-img 
                v-else
                max-height="250px"
                src="../assets/nophoto.jpg"
                alt="no image"
                contain
              >

              </v-img>
              
              
              <div class="container card-actions mx-auto">
                <div class="align-text-bottom"><p>Listed By: {{listing.ListAgentFullName}} - {{listing.ListOfficeName}}</p></div>
                <div class="row">
                  <div class="col-sm border-top border-right">
                    <router-link :to="{ path: 'property', query: { listingKey: listing.ListingKey }}">
                    <button class="btn btn-lg btn-block btn-primary">View Property</button>
                    </router-link>
                  </div>
                  <!-- <div class="col-sm border-top"> Property('a425784137554b6f5109b8b6510256ba')
                    <button class="btn btn-primary btn-lg btn-block">Contact Us</button>
                  </div> -->
                  
                </div>
              </div>

              
              <!-- <v-divider></v-divider> -->
             

              
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <span class="grey--text">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                text
                color="primary"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
              >
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
             <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
     
    <!-- <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>&nbsp; -->

    
  </div>
</template>
<script>
import axios from 'axios';
import Search from '../components/Search'
export default {
  data() {
/**
     * @typedef {this} NewType
     */

    return {
        error: null,
        listings: [],
        loading: true,
        rowsPerPageItems: [12, 24, 36],
        images: null,
        itemsPerPageArray: [8, 16, 24],
        search: this.$route.query.param,
        query: this.$route.query.param,
        baths: this.$route.query.baths,
        beds: this.$route.query.beds,
        filter: "ListOfficeMlsId eq '4204'",
        sort: 'ListPrice desc',
        sortAsc:'ListPrice asc',
        page: 1,
        itemsPerPage: 16,
        top:"100",
        sortBy: 'desc',
        keys:[
          {'List Price': "ListPrice"},
          {'Bedrooms': "BedroomsTotal"},
          {'Bathrooms': "BathroomsTotalInteger"},
          {'Sq. Ft.': "LivingArea"}
        ],
        
      };
  },
  computed: {
    numberOfPages () {
      return Math.ceil(this.listings.length / this.itemsPerPage)
    },
    filteredKeys () {
      return this.keys.filter(key => key !== `ListPrice`)
    },
  },
  methods: {
    formatPrice(value) {
        let val = (value/1).toFixed(0).replace(',', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    nextPage () {
      if (this.page + 1 <= this.numberOfPages) this.page += 1
    },
    formerPage () {
      if (this.page - 1 >= 1) this.page -= 1
    },
    updateItemsPerPage (number) {
      this.itemsPerPage = number
    },
    searchListings(){
      this.$router.push("/search?param="+this.search);
      
    }
  },
  created (){
    console.log(this.$route.query.param);
      // "https://api.bridgedataoutput.com/api/v2/actris/listings?access_token=c03d8edc2e18155f1d8d782866904cfa&sortBy=ListPrice&order=desc&City="+this.query+"&BathroomsTotalInteger.gte="+this.baths+"&BedroomsTotal.gte="+this.beds+""
    
      axios
      .get("https://api.bridgedataoutput.com/api/v2/actris/listings?access_token=c03d8edc2e18155f1d8d782866904cfa&sortBy=ListPrice&order=desc&City="+this.query+"&BathroomsTotalInteger.gte="+this.baths+"&BedroomsTotal.gte="+this.beds)
      .then(response => {
        console.log(response)
        this.listings = response.data.bundle
        console.log(this.listings)
        Object.keys(this.listings).forEach(keys =>{
            if(this.listings[keys].PhotosCount > 0){
                console.log(this.listings[keys].Media)
            }
            
           
        })
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.loading = false)
  },
  components: {
    Search: Search
  }
}
</script>
<style>
.listings{
    margin-top: 80px;
}
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
.price-box {
  background-color: #eceeee;
  margin-top: 25px;
  margin-left: -5px;
  margin-right: -5px;
  padding-bottom: 15px;
  border-top-width: 1px;
  border-bottom: 1px solid #d3d4d4;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
#listing .thumbnail {
  min-height: 700px;
}
.thumbnail {
  display: block;
  padding: 4px;
  margin-bottom: 20px;
  line-height: 1.42857143;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  -webkit-transition: border 0.2s ease-in-out;
  -o-transition: border 0.2s ease-in-out;
  transition: border 0.2s ease-in-out;
}
.sold {
    display: inline-block;
    color: #993333;
}
</style>